export const ACTIONS = {
  STATEMENT_NAV_OPEN: 'STATEMENT_NAV_OPEN',
  GL_CONFIGURATION_NAV_OPEN: 'GL_CONFIGURATION_NAV_OPEN',
  JOURNALS_NAV_OPEN: 'JOURNALS_NAV_OPEN',
  DASHBOARD_NAV_OPEN: 'DASHBOARD_NAV_OPEN',
};
export const NAMESPACER = {
  SUPPORT: 'SUPPORT',
};
